$(document).ready(function () {
    function updateVariantId() {
        $('.quantity-break').each(function () {
            var inputItem = $(this).find('[name="mrk-quantity"]');
            if ($(inputItem).is(':checked')) {
                console.log($(this), inputItem);
                $(this).find('.quantity-break__selector-item').each(function () {
                    var variantId = null;
                    var color = null;
                    var selectedOptions = [];
                    var options = $(this).find('select').val();
                    $(this).find('select').each(function () {
                        selectedOptions.push($(this).val());
                    });
                    console.log(selectedOptions);
                    // Fetch variants from the JSON script tag within the quantity-breaks element
                    var variants = window.mrkVariants;
                    variants.forEach(function (variant) {
                        var options = variant.options;
                        if (JSON.stringify(options) === JSON.stringify(selectedOptions)) {
                            variantId = variant.id;
                            color = selectedOptions[0];
                            if(variant.available){
                              $(this).find('.mrk-error').html('');
                            }else{
                              $(this).find('.mrk-error').html(`${variant.title} is unavailable!`);
                            }
                        }
                    });

                    $(this).attr('data-selected-id', variantId).attr('data-selected-color', color);

                });
            }
        });
    }
    function createHiddenSubscription(index){
      var variantId = $('.mrk-addon-id:checked').val();
      var quantity = 1;
      var subscription = $('.mrk-subscription-coaching').val();
      if (variantId) {
          var hiddenInputId = $('<input>').attr({
              type: 'hidden',
              name: `items[${index}][id]`,
              value: variantId
          });
          var hiddenSubscription = '';
          if(subscription != ''){
              hiddenSubscription = $('<input>').attr({
                  type: 'hidden',
                  name: `items[${index}][selling_plan]`,
                  value: subscription
              });
          }
          var hiddenInputQuantity = $('<input>').attr({
              type: 'hidden',
              name: `items[${index}][quantity]`,
              value: quantity
          });
          
          $('.mrk-hidden-inputs').append(hiddenInputId,hiddenInputQuantity,hiddenSubscription);
      }
    }
    function createHiddenInputs() {
        $('.mrk-hidden-inputs').html('');
        $('[name="id"]').prop('disabled', true);
        var index = 0;
        $('.quantity-break').each(function () {
            var inputItem = $(this).find('[name="mrk-quantity"]');
            if ($(inputItem).is(':checked')) {
                $(this).find('.quantity-break__selector-item').each(function () {
                    var variantId = $(this).attr('data-selected-id');
                    var color = $(this).attr('data-selected-color');
                    var quantity = 1;
                    if (variantId) {
                        var hiddenInputId = $('<input>').attr({
                            type: 'hidden',
                            name: `items[${index}][id]`,
                            value: variantId
                        });
                        var hiddenInputColor = $('<input>').attr({
                            type: 'hidden',
                            name: `items[${index}][properties[Color]]`,
                            value: color
                        });

                        var hiddenInputQuantity = $('<input>').attr({
                            type: 'hidden',
                            name: `items[${index}][quantity]`,
                            value: quantity
                        });
                        
                        $('.mrk-hidden-inputs').append(hiddenInputId,hiddenInputColor,hiddenInputQuantity);
                        index = index + 1;
                    }
                })
            }
        });
        // createHiddenSubscription(index);
        if($('.quantity-break__selector-item').length == 0){
           $('[name="id"]').removeAttr('disabled');
            var quantity = $('[name="mrk-quantity"]:checked').val();
            var hiddenInputQuantity = $('<input>').attr({
                type: 'hidden',
                name: `quantity`,
                value: quantity
            });
            
            $('.mrk-hidden-inputs').append(hiddenInputQuantity);
        }
    }

    // Event listener for change on any select
    $('.mrk-bundles-option').on('change', function () {
        updateVariantId();
        createHiddenInputs();
    });
    $('[name="mrk-quantity"],[name="selling-plan"],.mrk-addon-id').on('change', function () {
        updateVariantId();
        createHiddenInputs();
    });
    // Initial update on page load
    updateVariantId();
    createHiddenInputs();
});